// extracted by mini-css-extract-plugin
module.exports = {"modal":"jgp-3B5KJ","icon":"jgp-278sn","donateButton":"jgp-2YP8h","dismissLink":"jgp-ErwM1"};